import { createFileRoute } from "@tanstack/react-router";
import { StuckReport } from "@/tours/StuckReport";

export const Route = createFileRoute("/_app/tours/stuck")({ component: StuckReport });
